import { Component, EventEmitter, Inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { DROP_CONTEXT_MENU_PARAMS, DropContextMenuParams } from '../../services/contextmenu.service';
import { CapabilitiesService } from 'src/app/services/capabilities.service';
import { CapabilityType } from 'src/app/models/capability-type';

@Component({
  selector: 'app-drop-context-menu',
  templateUrl: './drop-context-menu.component.html',
  styleUrls: ['./drop-context-menu.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None
})
export class DropContextMenuComponent {
  @Input() position: { x: number, y: number } = { x: 0, y: 0 };
  @Output() removeDrop = new EventEmitter<string>();
  @Output() clearDrop = new EventEmitter<string>();
  @Output() copyDrop = new EventEmitter<string>();
  @Output() pasteDropBefore = new EventEmitter<string>();
  @Output() pasteDropAfter = new EventEmitter<string>();
  @Output() createDropBefore = new EventEmitter<string>();
  @Output() createDropAfter = new EventEmitter<string>();
  @Output() pasteShelf = new EventEmitter<string>();
  @Output() createShelf = new EventEmitter<string>();
  @Output() dropSettings = new EventEmitter<string>();

  expandedMenu: string | null = null;

  constructor(@Inject(DROP_CONTEXT_MENU_PARAMS) public params: DropContextMenuParams,
    private capabilitiesService: CapabilitiesService) {}

  get canEdit(): boolean {
    return this.capabilitiesService.hasCapability(CapabilityType.EDIT_PLANOGRAM);
  }

  toggleSubmenu(menu: string, event: Event) {
    event.stopPropagation();
    this.expandedMenu = this.expandedMenu === menu ? null : menu;
  }
}